import api from "../config/api";
import { TaskComment } from "../types/TaskComment";

const API_URL = "/taskComment";

export const getTaskComments = () =>
  api.get(`${API_URL}/`).then((res) => {
    return res.data.data;
  });

export const getTaskCommentById = (id: string) =>
  api.get(`${API_URL}/?id=${id}`);

export const createTaskComment = (data: TaskComment) =>
  api.post(`${API_URL}/`, data);

export const updateTaskComment = (id: number, data: TaskComment) =>
  api.put(`${API_URL}/?id=${id}`, data);

export const deleteTaskComment = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
